import { render, staticRenderFns } from "./DialogTitle.vue?vue&type=template&id=d04059e2&scoped=true"
import script from "./DialogTitle.vue?vue&type=script&lang=js"
export * from "./DialogTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04059e2",
  null
  
)

export default component.exports